<template>
  <section
    id="start-free"
    class="padding-top-5xl"
  >
    <div class="row margin-bottom-4xl text-center">
      <div class="column-12">
        <h2
          class="text-uppercase size-md with-anchor"
          style="letter-spacing: var(--letter-spacing-3xl); font-weight: var(--font-weight-black); color: var(--fa-md-gravy)"
        >
          <anchor-link
            anchor="#start-free"
            link-color="gravy"
            anchor-name="Start for Free"
          />
          No Reservations Required
        </h2>
        <h1 class="h2 margin-y-md">1 line of code&hellip; 1 million+ icons.</h1>
        <p class="line-length-xl margin-auto">
          No need to download, install, or manage files. Our Kits CDN does it all with a single line of code. With Font Awesome Free, you get easy access to
          over {{ freeIconsRounded }} icons.
          <site-link
            :to="{ name: 'plans' }"
            @click.native="$posthog.capture('upgrade_link_click', { context: 'home_view' })"
            >Upgrade to a Pro plan</site-link
          >
          for even more.
        </p>
      </div>
    </div>
    <div class="margin-bottom-4xl tablet:margin-bottom-5xl laptop:margin-bottom-4xl">
      <div
        class="row align-middle align-center message margin-bottom-0 tablet:padding-y-3xl"
        style="--message-background: var(--white); --link-color: var(--fa-dk-gravy); --link-hover-color: var(--fa-blue)"
      >
        <div class="column-12 laptop:column-3 margin-bottom-2xl laptop:margin-bottom-0 padding-0">
          <img
            src="https://img.fortawesome.com/1ce05b4b/start-illustration-homepage.svg"
            alt="Rocket icon blasting off with a sun in the background"
            class="margin-auto"
          />
        </div>
        <start-form
          class="column-12 laptop:column-9 text-left"
          :has-arrived-from-figma="false"
        />
      </div>
    </div>
  </section>
</template>

<script>
  import { StartMixin } from 'app/views/start/mixins'
  import accounting from 'accounting'
  import StartForm from 'app/views/start/components/StartForm'
  import AnchorLink from '../components/AnchorLink'

  export default {
    name: 'StartFree',

    components: {
      StartForm,
      AnchorLink
    },

    mixins: [StartMixin],

    props: {
      isSignedIn: {
        type: Boolean,
        default: false
      },
      hasArrivedFromFigma: {
        type: Boolean
      }
    },

    computed: {
      freeIconsRounded() {
        const freeIcons = this.$counts.icons.free.value
        const roundedIcons = Math.floor(freeIcons / 1000) * 1000

        return accounting.formatNumber(roundedIcons)
      }
    }
  }
</script>
